import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import { useScreen, useRouter } from "hooks";
import SearchLinksPresenter from "presenters/SearchLinksPresenter";

import useStyles from "./useStyles";

const Navigation = ({ searchLinks }) => {
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { pathname } = useRouter();

  const isIncluded = searchLinks?.some((searchLink) => searchLink.url === pathname);

  const renderSearchLink = (searchLink) => {
    const name = SearchLinksPresenter.name(searchLink);
    return (
      <NavLink
        id={`header-${name.replaceAll(" ", "-").toLowerCase()}`}
        exact
        activeClassName={classes.activelink}
        key={SearchLinksPresenter.id(searchLink)}
        className={classes.link}
        to={SearchLinksPresenter.url(searchLink)}
        isActive={(match) => (isIncluded ? match : true)}
      >
        {name}
      </NavLink>
    );
  };

  return (
    <div className={classes.root}>
      {searchLinks && isDesktop && searchLinks.map((searchLink) => renderSearchLink(searchLink))}
    </div>
  );
};

Navigation.propTypes = {
  searchLinks: PropTypes.arrayOf(PropTypes.shape()),
};

export default Navigation;

// JJR-171 New menu
//   return (
//     <div className={classes.root}>
//       <NavLink exact className={classes.link} activeClassName={classes.linkActive} to={appRoutes.rootPath()}>
//         Home
//       </NavLink>
//       {UserPresenter.isRegistered(currentUser) && (
//         <NavLink className={classes.link} activeClassName={classes.linkActive} to={appRoutes.myEcardsPath()}>
//           Ecards
//         </NavLink>
//       )}
//       <NavLink className={classes.link} activeClassName={classes.linkActive} to={appRoutes.videosPath()}>
//         Videos
//       </NavLink>
//       {R.isNil(currentUser) && !isDesktop ? (
//         <NavLink className={classes.signUpLink} activeClassName={classes.signUpLinkActive} to={appRoutes.signUpPath()}>
//           Sign Up
//         </NavLink>
//       ) : (
//         <NavLink
//           className={classes.link}
//           activeClassName={classes.linkActive}
//           to={appRoutes.contentfulPagePath("artists-page")}
//         >
//           Artists
//         </NavLink>
//       )}
//     </div>
//   );
// };

// export default Navigation;
